(function () {
  'use strict';
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  // Disable on touch devices
  if (window.matchMedia('(hover: none) and (pointer: coarse)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.innerWidth < 900) return;

  var ring = document.createElement('div');
  ring.className = 'c-ring-cursor';
  ring.setAttribute('aria-hidden', 'true');

  var dot = document.createElement('div');
  dot.className = 'c-ring-cursor__dot';
  dot.setAttribute('aria-hidden', 'true');

  document.body.appendChild(ring);
  document.body.appendChild(dot);

  var rx = window.innerWidth / 2, ry = window.innerHeight / 2;
  var dx = rx, dy = ry;
  var tx = rx, ty = ry;

  function onMove(e) {
    tx = e.clientX;
    ty = e.clientY;
    dot.style.transform = 'translate3d(' + (tx - 3) + 'px, ' + (ty - 3) + 'px, 0)';
  }
  document.addEventListener('mousemove', onMove, { passive: true });

  function tick() {
    rx += (tx - rx) * 0.18;
    ry += (ty - ry) * 0.18;
    ring.style.transform = 'translate3d(' + (rx - 18) + 'px, ' + (ry - 18) + 'px, 0)';
    requestAnimationFrame(tick);
  }
  requestAnimationFrame(tick);

  // Hover state on interactive elements
  var hoverSel = 'a, button, [role="button"], [role="tab"], summary, .c-btn, .c-nav__link, .p-features-marquee__nav, .p-product-showcase__swatch';
  document.addEventListener('mouseover', function (e) {
    if (e.target.closest && e.target.closest(hoverSel)) ring.classList.add('is-hover');
  }, { passive: true });
  document.addEventListener('mouseout', function (e) {
    if (e.target.closest && e.target.closest(hoverSel)) ring.classList.remove('is-hover');
  }, { passive: true });

  document.addEventListener('mouseleave', function () { ring.style.opacity = '0'; dot.style.opacity = '0'; }, { passive: true });
  document.addEventListener('mouseenter', function () { ring.style.opacity = ''; dot.style.opacity = ''; }, { passive: true });
})();
